import { Factory } from './Factory'
import { FormInputFactory} from './FormInputFactory'
export class FormColumnFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  create() {
    return {
      id: this.id('form-column'),
      containerClasses: {
        desktop: [{property: "ColumnWidth", touched: false, value: "WIDTH_12_12"}],
        tablet: [{property: "ColumnWidth", touched: false, value: "WIDTH_12_12"}],
        phone: [{property: "ColumnWidth", touched: false, value: "WIDTH_12_12"}],
      },
      components: [(new FormInputFactory).create()]
    }
  }
}